import { makeAutoObservable } from 'mobx';

import { VenueServiceModel } from '../model';

class VenueServiceStore {
  services: VenueServiceModel[];

  constructor() {
    this.services = [];
    makeAutoObservable(this);
  }

  setServices(services: VenueServiceModel[]) {
    this.services = services;
  }
}

const venueServiceStoreImpl = new VenueServiceStore();
export default venueServiceStoreImpl;
